import React, { useState } from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  Chip,
  Divider,
  TextField,
  InputAdornment,
  Tab,
  Tabs
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddShoppingCartRoundedIcon from '@mui/icons-material/AddShoppingCartRounded';
// import AddonListing from '../AddonManager';
// import PlanUpgrade from '../PlanUpgrade';
import SubCard from 'ui-component/cards/SubCard';
import AddonListing from '../company/AddonListing';
import PlanUpgrade from '../company/PlanUpgrade';
import Subdetails from './Subdetails';
import TransactionHistory from './TransactionHistory';
// import Subdetails from './Subdetails';

export default function SubscriptionDashboard() {
  const [activeTab, setActiveTab] = useState(0);

  // Large Catalog of Add-ons / Plugins
  const allAddons = [
    { id: 1, name: 'Advanced Abandoned Cart Recovery', price: '$9/mo', category: 'Marketing', desc: 'Automated SMS & Email flows.' },
    { id: 2, name: 'Multi-Vendor Marketplace Pack', price: '$29/mo', category: 'Operations', desc: 'Turn your store into a multi-seller hub.' },
    { id: 3, name: 'B2B Wholesale Tier Pricing', price: '$19/mo', category: 'Sales', desc: 'Set custom volume rules for bulk buyers.' },
    { id: 4, name: 'AI Product Recommendation Engine', price: '$15/mo', category: 'Marketing', desc: 'Personalized upsells on checkout pages.' },
    { id: 5, name: 'Global Tax Automation (Avalara)', price: '$12/mo', category: 'Operations', desc: 'Real-time global VAT compliance calculation.' },
    { id: 6, name: 'Custom Mobile App Builder', price: '$49/mo', category: 'Sales', desc: 'Generate native iOS & Android apps.' },
  ];



  return (

    <Box sx={{ bgcolor: '#f8fafc', height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <Box
        sx={{
          px: 3,
          pt: 3,
          pb: 2,
          // background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
          color: "#0e0202",
          borderBottom: "1px solid #e2e8f0"
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 0.5
          }}
        >
          Subscription
        </Typography>


      </Box>
      {/* Tab Navigation Controls */}
      <Box sx={{ p: 3, pb: 0, borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, bgcolor: '#ffffff' }}>
        <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)} size="small" sx={{ minHeight: '48px' }}>
          <Tab label="Current" sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.9rem' }} />
          <Tab label="Upgrade" sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.9rem' }} />
          <Tab label="Addons Plan" sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.9rem' }} />
          <Tab label="Transaction History" sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.9rem' }} />
        </Tabs>

        
      </Box>

      {/* Main Full Screen View Area Area */}
      <Grid container sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <Grid item xs={12} sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 3 }}>
          <Box sx={{ flexGrow: 1, overflowY: 'auto', pr: 1, pb: 4 }}>

            {/* TAB 0: DETAILS (Your original marketplace display now houses current info) */}
            {activeTab === 0 && (
              <SubCard>

                <Subdetails />
              </SubCard>
            )}

            {/* TAB 1: ADDONS */}
            {activeTab === 1 && (
              <Box>
                <PlanUpgrade />

              </Box>
            )}

            {/* TAB 2: UPGRADE PLAN */}
            {activeTab === 2 && (
              <Box>

                <AddonListing />


              </Box>

            )}
            {activeTab === 3 && (
              <Box>

                <TransactionHistory />


              </Box>

            )}

          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}